import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { userSignIn } from '../../actions/app/app';
import { hideModal } from '../../actions/modal/modal';

const SignInForm = props => {

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        formik = useFormik({
          initialValues: {
            username: '',
            password: ''
          },
          validationSchema: Yup.object({
            password: Yup.string().required('Password is required'),
            username: Yup.string().required('Email address is required')
          }),
          onSubmit: values => {
            dispatch(
              userSignIn(
                JSON.stringify({
                  username: values.username,
                  password: values.password
                })
              )
            );
          }
        });

  return (
    <>
      <span className="modal__close" onClick={ () => dispatch(hideModal()) }>&times;</span>
      
      <form onSubmit={ formik.handleSubmit } className="form form--restricted">
        <div className="form__group">
          <label className="form__label" htmlFor="username">Email address</label>
          <input className="form__input" placeholder="Enter your email address" autoFocus={ true } id="username" value={ formik.values.username } onChange={ formik.handleChange } name="username" type="text" />
          { formik.touched.username && formik.errors.username ? (<span className="form__error-item">{ formik.errors.username }</span>) : ''}
        </div>
        
        <div className="form__group">
          <label className="form__label" htmlFor="password">Password</label>
          <input className="form__input" placeholder="Enter your password" id="password" value={ formik.values.password } onChange={ formik.handleChange } name="password" type="password" />
          { formik.touched.password && formik.errors.password ? (<span className="form__error-item">{ formik.errors.password }</span>) : ''}
        </div>

        <div className="form__button-group">
          <span className="form__button button button--hollow" onClick={ props.recoverPasswordEvent }>Forgot password?</span>
          <button type="submit" className="form__button button" disabled={ appProps.loading || !formik.dirty }>Sign in</button>
        </div>

        <p className="form__help-text" style={{ fontSize: '.85rem' }}>Want to add your own sightings?<br/><span className="form__help-link" onClick={ props.signUpEvent }>Sign up</span> to Koala Map for free to add your own sightings!</p>
        {/* <p className="form__help-text">Don't have an account? >Sign up!</span></p> */}
      </form>
    </>
  );

}

export default SignInForm;